<template>
  <div class="t-space-x-1">
    <div
      @click="onStatusClick('all')"
      class="t-inline-block t-rounded-2xl t-border t-py-1 t-px-3 t-font-semibold t-cursor-pointer"
      :class="(status === 'all') ? 't-bg-blue-50 t-text-dodger-blue t-border-dodger-blue': 't-border-gray-400 t-text-black t-bg-gray-100'"
    >
      All
    </div>
    <div
      @click="onStatusClick('booked')"
      class="t-inline-block t-rounded-2xl t-border t-py-1 t-px-3 t-font-semibold t-cursor-pointer"
      :class="(status === 'booked') ? 't-bg-blue-50 t-text-dodger-blue t-border-dodger-blue': 't-border-gray-400 t-text-black t-bg-gray-100'"
    >
      <i class="fas fa-bookmark"></i>
      Booked
    </div>
    <div
      @click="onStatusClick('in transit')"
      class="t-inline-block t-rounded-2xl t-border t-py-1 t-px-3 t-font-semibold t-cursor-pointer"
      :class="(status === 'in transit') ? 't-bg-blue-50 t-text-dodger-blue t-border-dodger-blue': 't-border-gray-400 t-text-black t-bg-gray-100'"
    >
      <i class="fas fa-truck fa-flip-horizontal"></i>
      In Transit
    </div>
    <div
      @click="onStatusClick('delivered')"
      class="t-inline-block t-rounded-2xl t-border t-py-1 t-px-3 t-font-semibold t-cursor-pointer"
      :class="(status === 'delivered') ? 't-bg-blue-50 t-text-dodger-blue t-border-dodger-blue': 't-border-gray-400 t-text-black t-bg-gray-100'"
    >
      <i class="fas fa-check"></i>
      Delivered
    </div>
    <div
      @click="onStatusClick('cancelled')"
      class="t-inline-block t-rounded-2xl t-border t-py-1 t-px-3 t-font-semibold t-cursor-pointer"
      :class="(status === 'cancelled') ? 't-bg-blue-50 t-text-dodger-blue t-border-dodger-blue': 't-border-gray-400 t-text-black t-bg-gray-100'"
    >
      <i class="fas fa-ban"></i>
      Cancelled
    </div>
    <div
        class="t-relative t-inline-block t-rounded-md t-border t-w-32 t-py-1 t-px-3 t-cursor-pointer"
        v-click-outside="() => this.showTimeDropdown = false"
    >
      <button @click="onTimeDropdownClick" class="t-flex t-justify-between t-items-center t-w-full focus:t-outline-none">
        {{ timeDropdownDisplay }}
        <i class="fas fa-chevron-down"></i>
      </button>

      <div v-show="showTimeDropdown" class="t-absolute t-origin-top-left t-left-0 t-z-10 t-mt-2 t-border t-border-gray-300 t-rounded-md t-w-32 t-bg-white">
        <div @click="onTimeSelected('day', 'Today')" class="t-px-3 t-py-1 hover:t-bg-gray-200">
          Today
        </div>
        <div @click="onTimeSelected('week', 'Past Week')" class="t-px-3 t-py-1 hover:t-bg-gray-200">
          Past Week
        </div>
        <div @click="onTimeSelected('month', 'Past Month')" class="t-px-3 t-py-1 hover:t-bg-gray-200">
          Past Month
        </div>
        <div @click="onTimeSelected('year', 'Past Year')" class="t-px-3 t-py-1 hover:t-bg-gray-200">
          Past Year
        </div>
        <div @click="onTimeSelected('all', 'All')" class="t-px-3 t-py-1 hover:t-bg-gray-200">
          All
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusSelector',
  emits: ['statusSelected'],
  data() {
    return {
      status: 'all',
      timeFrame: '',
      showTimeDropdown: false,
      timeDropdownDisplay: 'All'
    }
  },
  methods: {
    onStatusClick(status) {
      this.status = status;
      this.showTimeDropdown = false;
      this.emitSelectedFields();
    },
    onTimeDropdownClick() {
      this.showTimeDropdown = !this.showTimeDropdown;
    },
    onTimeSelected(selectedTime, timeDisplay) {
      this.timeFrame = selectedTime;
      this.timeDropdownDisplay = timeDisplay;
      this.showTimeDropdown = false;
      this.emitSelectedFields();
    },
    emitSelectedFields() {
      this.$emit('statusSelected', this.status, this.timeFrame);
    }
  }
}
</script>

<style scoped>

</style>